"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.learningPanel = exports.learningPanelFree = exports.LoginApi = exports.CommunicationHubAPIs = exports.UserDeletionAPIs = exports.CustomLessonsApi = exports.CourseBuilderApi = exports.CustomCoursesApi = exports.AwsAPI = exports.auth = exports.combinePlatformUrl = void 0;
var combinePlatformUrl_1 = require("./combinePlatformUrl");
Object.defineProperty(exports, "combinePlatformUrl", { enumerable: true, get: function () { return __importDefault(combinePlatformUrl_1).default; } });
var authApi_1 = require("./authApi");
Object.defineProperty(exports, "auth", { enumerable: true, get: function () { return __importDefault(authApi_1).default; } });
__exportStar(require("./fetchAdminDashboardData"), exports);
__exportStar(require("./registration"), exports);
var awsApi_1 = require("./learningPanelFree/awsApi");
Object.defineProperty(exports, "AwsAPI", { enumerable: true, get: function () { return __importDefault(awsApi_1).default; } });
var customCoursesApi_1 = require("./customCoursesApi");
Object.defineProperty(exports, "CustomCoursesApi", { enumerable: true, get: function () { return __importDefault(customCoursesApi_1).default; } });
var courseBuilderApi_1 = require("./courseBuilderApi");
Object.defineProperty(exports, "CourseBuilderApi", { enumerable: true, get: function () { return __importDefault(courseBuilderApi_1).default; } });
var customLessonsApi_1 = require("./customLessonsApi");
Object.defineProperty(exports, "CustomLessonsApi", { enumerable: true, get: function () { return __importDefault(customLessonsApi_1).default; } });
var userDeletionApi_1 = require("./userDeletionApi");
Object.defineProperty(exports, "UserDeletionAPIs", { enumerable: true, get: function () { return __importDefault(userDeletionApi_1).default; } });
var communicationHub_1 = require("./communicationHub");
Object.defineProperty(exports, "CommunicationHubAPIs", { enumerable: true, get: function () { return __importDefault(communicationHub_1).default; } });
var loginApi_1 = require("./loginApi");
Object.defineProperty(exports, "LoginApi", { enumerable: true, get: function () { return __importDefault(loginApi_1).default; } });
exports.learningPanelFree = __importStar(require("./learningPanelFree"));
exports.learningPanel = __importStar(require("./learningPanel"));
__exportStar(require("./playLesson"), exports);
